/**
 * @desc 审批
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.WarehouseCostPayRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/warehouseCost/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
